import React from 'react'
import styled from '@emotion/styled'

const SectionTitleWrapper = styled.div`
	${({ theme }) => theme.fonts.primarySemiBold};
	font-size: 1.75rem;
	color: ${({ theme, variant }) => theme.colors[variant] || theme.sectionTitle.textColor};

	${({ theme }) => theme.MQ.M} {
		font-size: 2.25rem;
	}
`

export function SectionTitle({ children, className, variant }) {
	return (
		<SectionTitleWrapper className={className} variant={variant}>
			{children}
		</SectionTitleWrapper>
	)
}
